import React, { useState } from "react";
import axios from "axios";

export default function Contact() {

  const [serverState, setServerState] = useState({
    submitting: false,
    status: null,
  });
  const handleServerResponse = (ok, msg, form) => {
    setServerState({
      submitting: false,
      status: { ok, msg },
    });
    if (ok) {
      form.reset();
    }
  };
  const handleOnSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    setServerState({ submitting: true });
    axios({
      method: "post",
      url: "https://formspree.io/f/xpznkdko",
      data: new FormData(form),
    })
      .then((r) => {
        handleServerResponse(true, "Terkirim!", form);
      })
      .catch((r) => {
        handleServerResponse(false, r.response.data.error, form);
      });
  };

  return (
    <>
      <div className="my-5">
        <h1 className="text-center">Contact Us</h1>
      </div>

      <div className="container contact-div">
        <div className="row">
          <div className="col-md-6 col-10 mx-auto">
          <form action="#" onSubmit={handleOnSubmit}>
              <div className="form-group">
                <label for="exampleFormControlInput1">Enter Full Name</label>
                <input
                  id="Nama" type="Nama" name="Nama" required
                  className="form-control"
                  placeholder="Enter Your Name"
                />
              </div>
              <div className="form-group pt-3">
                <label for="exampleFormControlInput1">Contact Number</label>
                <input
                  id="Whatsapp" type="Whatsapp" name="Whatsapp" required
                  className="form-control"
                  placeholder="+62"
                />
              </div>
              <div className="form-group pt-3">
                <label for="exampleFormControlInput1">Email address</label>
                <input
                  id="email" type="email" name="email" required
                  className="form-control"
                  placeholder="name@example.com"
                />
              </div>

              <div className="form-group pt-3">
                <label for="exampleFormControlTextarea1">
                  Type your Message Here
                </label>
                <textarea
                  id="pesan" type="pesan" name="pesan" required
                  className="form-control"
                  rows="3"
                  placeholder="Message"
                ></textarea>
              </div>

              <div className="col-12 pt-3">
                <button
                  type="submit"
                  disabled={serverState.submitting}
                  className="btn btn-outline-primary"
                >
                  Submit form
                </button>
                {serverState.status && (
                    <p className={!serverState.status.ok ? "errorMsg" : ""}>
                      {serverState.status.msg}
                    </p>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

